

import * as React from "react";
import {useEffect } from "react";
import { Box, Typography } from "@mui/joy";

const Privacy: React.FC = () => {

   useEffect(() => {
       document.title = "Privacy | Iskcon Kanpur";
   }, []);
   
  return (
    <Box
      sx={{
        maxWidth: "800px",
        margin: "auto",
        padding: "20px",
        textAlign: "left",
      }}
    >
      <Typography level="h1" fontSize="1.8rem" sx={{ mb: 2 }}>
        Privacy Policy
      </Typography>
      <Typography level="body-md" sx={{ mb: 2 }}>
        Welcome to Iskcon Kanpur! Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you use our services.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        1. Information We Collect
      </Typography>
      <Typography level="body-md">
        - Personal Information: When you register or use our services, we may collect details such as your name, email address, phone number, and payment information.
        <br />
        - Usage Data: We collect information about how you interact with our platform, including pages visited, features used, and actions taken.
        <br />
        - Cookies & Tracking: We use cookies to enhance your experience and analyze user behavior.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        2. How We Use Your Information
      </Typography>
      <Typography level="body-md">
        - To provide and improve our services.
        <br />
        - To communicate with you regarding updates, transactions, and customer support.
        <br />
        - To enhance security and prevent fraud.
        <br />
        - To comply with legal obligations.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        3. How We Share Your Information
      </Typography>
      <Typography level="body-md">
        - We do not sell your personal data.
        <br />
        - We may share your data with trusted service providers who help operate our platform.
        <br />
        - Legal Compliance: We may disclose information if required by law or to protect our legal rights.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        4. Data Security
      </Typography>
      <Typography level="body-md">
        - We implement industry-standard security measures to protect your data.
        <br />
        - However, no system is completely secure. Please use strong passwords and be cautious of phishing attempts.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        5. Your Rights and Choices
      </Typography>
      <Typography level="body-md">
        - You can update or delete your account information at any time.
        <br />
        - You can opt-out of marketing emails by adjusting your preferences.
        <br />
        - You may request a copy of the data we store about you.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        6. Changes to this Policy
      </Typography>
      <Typography level="body-md">
        We may update this Privacy Policy from time to time. Changes will be posted on this page, and we encourage you to review them periodically.
      </Typography>

      <Typography level="body-md" sx={{ mt: 3, fontStyle: "italic" }}>
        If you have any questions about this Privacy Policy, please contact us.
      </Typography>
    </Box>
  );
};

export default Privacy;